import { APP_NAME, APP_TAGLINE } from '../config'

interface HeaderProps {
  userName?: string
  onSignOut?: () => void
  onNewChat?: () => void
  onShowHistory?: () => void
}

export function Header({ userName, onSignOut, onNewChat, onShowHistory }: HeaderProps) {
  return (
    <header className="header">
      <div className="header__brand">
        <span className="header__mark" aria-hidden />
        <div>
          <p className="header__title">{APP_NAME}</p>
          <p className="header__tagline">{APP_TAGLINE}</p>
        </div>
      </div>

      {userName && (
        <div className="header__actions">
          <button type="button" className="btn btn--ghost" onClick={onShowHistory}>
            History
          </button>
          <button type="button" className="btn btn--ghost" onClick={onNewChat}>
            New chat
          </button>
          <span className="header__user" title={userName}>
            {userName}
          </span>
          <button type="button" className="btn btn--ghost" onClick={onSignOut}>
            Sign out
          </button>
        </div>
      )}
    </header>
  )
}
